import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

type InputValue = Date | string | number | null | undefined;

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy';

  if (!date) return '';
  
  const dateObj = new Date(date);
  
  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    return '';
  }

  return format(dateObj, fm);
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy p';

  if (!date) return '';
  
  const dateObj = new Date(date);
  
  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    return '';
  }

  return format(dateObj, fm);
}

export function fTimestamp(date: InputValue) {
  if (!date) return '';
  
  const dateObj = new Date(date);
  
  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    return '';
  }

  return getTime(dateObj);
}

export function fToNow(date: InputValue) {
  if (!date) return '';
  
  const dateObj = new Date(date);
  
  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    return '';
  }

  return formatDistanceToNow(dateObj, {
    addSuffix: true,
  });
}
